import React from "react";
import StudentInfoTable from "./pages/StudentInfoTable";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import StudentsInfoAdd from "./pages/StudentsInfoAdd";
import PrivateRoute from "./pages/PrivateRoute";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/info/:slug" element={<StudentInfoTable />} />
        <Route
          path="/info/add"
          element={
            <PrivateRoute>
              <StudentsInfoAdd />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
